f<template>
  <div class="main-content-container customers-list-container-admin">
    <div class="top-content-container">
      <b-row>
        <b-col md="8">
          <b-breadcrumb class="customer-breadcrumbs pb-2">
            <b-breadcrumb-item class="breadcrumb-item-disabled">
              <span class="text-uppercase font-family-medium"> Customers </span>
            </b-breadcrumb-item>
          </b-breadcrumb>
          <h1
            class="
              font-lg
              primary-dark
              font-family-medium
              position-relative
              content-title
            "
          >
            Customers
          </h1>
        </b-col>
        <div
          class="
            add-customer-btn-container
            justify-content-end
            position-relative
          "
        ></div>

        <div class="filter-by-container">
          <p class="d-inline secondary--text position-relative">Filter By</p>

          <div class="d-flex">
            <b-form-group class="mr-3">
              <b-form-select
                v-model="selectedCompanyId"
                :options="companies"
                @change="applyFilters"
                data-cy="customers-filter-company"
              ></b-form-select>
            </b-form-group>

            <b-form-group class="mr-3" style="width: 20rem">
              <b-form-select
                class="cy-clist-customer-name"
                v-model="selectedCustomer"
                :options="customerNames"
                @change="applyFilters"
                data-cy="customers-filter-customer"
              ></b-form-select>
            </b-form-group>

            <b-form-group class="mr-3">
              <b-form-select
                class="cy-clist-sub-type"
                v-model="selectedSubscriptionId"
                :options="subscriptionTypes"
                @change="applyFilters"
                data-cy="customers-filter-subscription"
              ></b-form-select>
            </b-form-group>
          </div>
        </div>
      </b-row>
    </div>
    <b-tabs
      v-model="tabIndex"
      @input="getActiveTab"
      class=""
      active-nav-item-class="danger"
      active-tab-class="font-weight-bold text-success"
    >
      <b-tab title="Current Customers">
        <CurrentCustomers
          ref="currentCustomers"
          :selectedSubscriptionId="selectedSubscriptionId"
          :filteredCustomerId="selectedCustomer"
          :selectedCompanyId="selectedCompanyId"
          v-if="tabIndex === 0"
        />
      </b-tab>

      <b-tab title="New Unassigned Customers">
        <UnassignedCustomers
          ref="unassignedCustomers"
          :selectedSubscriptionId="selectedSubscriptionId"
          :filteredCustomerId="selectedCustomer"
          :selectedCompanyId="selectedCompanyId"
          v-if="tabIndex === 1"
        />
      </b-tab>
      <b-tab title="Archived Customers">
        <ArchivedCustomers
          ref="archivedCustomers"
          :selectedSubscriptionId="selectedSubscriptionId"
          :filteredCustomerId="selectedCustomer"
          :selectedCompanyId="selectedCompanyId"
          v-if="tabIndex === 2"
        />
      </b-tab>
    </b-tabs>
    <b-avatar
      button
      @click="$router.push({ name: 'AddCustomer' })"
      size="4.8rem"
      class="
        cy-add-customer-fab
        floating-action-btn
        btn-danger
        mb-5
        position-fixed
        cursor-pointer
      "
    >
      <img src="@/assets/icons/floating_plus.svg" alt="" />
    </b-avatar>
  </div>
</template>

<script>
import CurrentCustomers from "./CurrentCustomers";
import UnassignedCustomers from "./UnassignedCustomers";
import ArchivedCustomers from "./ArchivedCustomers";
import { getFilterCustomers } from "@/apis/customers";
import { getCompaniesMinimal, getMemberships } from "@/apis/companies";
export default {
  name: "CustomersList",
  components: {
    CurrentCustomers,
    UnassignedCustomers,
    ArchivedCustomers
  },
  data() {
    return {
      allCustomers: [],
      customerNames: [{ text: "Customer name", value: null }],
      isLoadingCurrentCustomers: true,
      isLoadingFilters: true,
      isLoadingUnassignedCustomers: true,
      isLoadingArchivedCustomers: true,
      isLoadingAllCustomers: true,
      currentCustomersList: [],
      unassignedCustomersList: [],
      archivedCustomersList: [],
      tabIndex: 0,
      selectedCompanyId: null,
      selectedCustomer: null,
      selectedSubscriptionId: null,
      company: "",
      selectedSubscriptionType: null,
      subscriptionTypes: [{ text: "Subscription type", value: null }],
      companies: [{ text: "Company name", value: null }],
      params: {}
    };
  },
  created() {
    const { tab, companyId } = this.$route.query;
    this.tabIndex = Number(tab);
    this.selectedCompanyId = companyId || null;
    this.populateCustomerFilter();
    this.populateCompanyFilter();
    this.populateSubscriptionTypes();
  },
  watch: {
    $route(to) {
      if (to.query && to.query.tab) {
        this.tabIndex = Number(to.query.tab);
      }
    }
  },

  methods: {
    getActiveTab() {
      this.selectedCustomer = null;
      this.selectedSubscriptionId = null;
      this.populateCustomerFilter();
      this.populateCompanyFilter();
      this.$router.push({
        name: "CustomersListAdmin",
        query: {
          tab: this.tabIndex
        }
      });
    },
    applyFilters() {
      if (this.tabIndex === 0) {
        this.$refs.currentCustomers.changeType();
      } else if (this.tabIndex === 1) {
        this.$refs.unassignedCustomers.changeType();
      } else {
        this.$refs.archivedCustomers.changeType();
      }
    },
    populateCustomerFilter() {
      let data;
      if (this.tabIndex === 0) {
        data = {
          is_assistant_assigned: true,
          is_active: true
        };
      } else if (this.tabIndex === 1) {
        data = {
          is_assistant_assigned: false,
          is_active: true
        };
      } else {
        data = {
          is_active: false
        };
      }
      getFilterCustomers(data).then(res => {
        this.customerNames = res.data.results.map(item => {
          return {
            text: `${item.fullname} `,
            value: item.id
          };
        });
        this.customerNames.unshift({
          value: null,
          text: "Customer name"
        });
      });
    },
    populateCompanyFilter(isActive = true) {
      getCompaniesMinimal(isActive).then(res => {
        this.companies = res.data.results.map(company => {
          return {
            text: `${company.name} `,
            value: company.id
          };
        });
        this.companies.unshift({
          value: null,
          text: "Company name"
        });
      });
    },
    populateSubscriptionTypes() {
      getMemberships().then(res => {
        this.subscriptionTypes = res.data.results.map(membership => {
          return {
            text: `${membership.title} `,
            value: membership.id
          };
        });
        this.subscriptionTypes = this.sortByText(this.subscriptionTypes);
        this.subscriptionTypes.unshift({
          value: null,
          text: "Subscription type"
        });
      });
    },

    // todo: make it a helper
    sortByText(list) {
      return list.sort((a, b) => {
        const textA = a.text.toUpperCase();
        const textB = b.text.toUpperCase();

        if (textA < textB) {
          return -1;
        }

        if (textA > textB) {
          return 1;
        }

        return 0;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.breadcrumb-item-disabled a {
  text-decoration: none;
  cursor: default;
}

.floating-action-btn {
  right: 3rem;
  z-index: 2;
  bottom: 0;
}
.customers-list-container-admin {
  margin-bottom: 5rem;
}
</style>
